import PropTypes from 'prop-types'

import template from './template.rt'
import './styles.css'

function ExternalMerch(props) {
  return template.call({ props })
}

ExternalMerch.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  ctaUrl: PropTypes.string.isRequired,
  ctaContent: PropTypes.string.isRequired,
  photo: PropTypes.string.isRequired,
  previewPhoto: PropTypes.string.isRequired,
  openImagesModal: PropTypes.func.isRequired
}

export default ExternalMerch
